export function LogoMark({ className = 'h-8 w-8' }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
      <path d="M9 20.5a11 11 0 0 1 22 0Z" fill="#D4771C" />
      <line x1="6" y1="20.5" x2="34" y2="20.5" stroke="#F7F5F0" strokeWidth="2.2" strokeLinecap="round" />
      <ellipse cx="20" cy="28.2" rx="3.2" ry="4.4" transform="rotate(-28 20 28.2)" fill="none" stroke="#9DB08A" strokeWidth="2" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark className={compact ? 'h-7 w-7' : 'h-9 w-9'} />
      <span className="font-sans text-[13px] font-semibold uppercase tracking-[0.3em] text-bone">
        Equinox Spices
      </span>
    </span>
  );
}
